import { configure } from 'axios-hooks'

import axios from './axios'
import cache from './cache'

configure({
  axios,
  cache,
})
